import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderService } from '../core/header/header.service';
import { DatacontextService } from '../data/datacontext.service';
import { Router } from '@angular/router';
import { TrialUserService } from 'src/app/shared/services/trial-user/trial-user.service';
import { AppSelectorService } from 'src/app/shared/services/app-selector/app-selector.service';
import { EnvironmentManagerService } from 'src/app/shared/services/environment-manager/environment-manager.service';
import { AmplitudeLoggerService } from '../shared/services/amplitude-logger/amplitude-logger.service';
import { AnalyticsEvents } from '../shared/constants/analytics-events';
import { AddUserComponent } from 'src/app/user-management/add-user/add-user.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FeatureListJsonService } from '../shared/services/config-manager/feature-list/feature-list-json.service';
import { cloneDeep } from 'lodash-es';
import { CreateAppComponent } from '../shared/components/create-app/create-app.component';
import { UtilService } from '../shared/services/util/util.service';
import { Title } from '@angular/platform-browser';
import { ExponentialBackoffRetryService, RETRY_STRATEGIES } from '../shared/services/exponential-backoff-retry/exponential-backoff-retry.service';
@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit, OnDestroy {
  public INVITE_CTA = AnalyticsEvents.eventAction.INVITE;
  public CREATE_CTA = AnalyticsEvents.eventAction.CREATE;
  private addUserDialogRef: MatDialogRef<AddUserComponent>;
  private companyDetails: any;
  private createAppDialogRef: MatDialogRef<CreateAppComponent>;
  public plan: any;
  public maxProductionAppCount: any = '';
  public productionAppCount = 0;
  public shouldStickToAppLimit = true;
  public shouldShowUploadFeature: Boolean = false;
  public cards = [
    {
      headTitle: 'Interaction Maps',
      img: 'assets/images/no_journey.png',
      bottomTitle: '',
      desc: 'Build Interactions Maps to reduce customer drop offs and grow your metrics',
      href: '/context-builder/nudge-journeys/',
      alias: 'im',
      featureName: 'interaction_maps',
      parentFeature: 'home_page',
      showPremium: false,
      shouldBeHidden: false
    },
    {
      headTitle: 'Display Nudges',
      img: 'assets/images/no_prompt.png',
      bottomTitle: '',
      desc: 'Use our plug and play templates to trigger Display Nudges without code and save your development time',
      href: '/actions/display-nudges',
      alias: 'temps',
      featureName: 'display_nudges',
      parentFeature: 'home_page',
      showPremium: false,
      shouldBeHidden: false
    },
    {
      headTitle: 'User Segments',
      img: 'assets/images/no-segments.png',
      bottomTitle: '',
      desc: 'Create user segments based on behavior data, user data and past history data',
      href: '/segments',
      alias: 'segs',
      featureName: 'user_segments',
      parentFeature: 'home_page',
      showPremium: false,
      shouldBeHidden: false
    },
    {
      headTitle: 'Native Nudges',
      img: 'assets/images/no_exp.png',
      bottomTitle: '',
      desc: 'Deliver Nudges on the native layer by adding configs and modifying them as needed',
      href: '/actions/product-variables',
      alias: 'cs',
      featureName: 'native_nudges',
      parentFeature: 'home_page',
      showPremium: false,
      shouldBeHidden: false
    },
    {
      headTitle: 'Data Sources',
      img: 'assets/images/no_data_source.png',
      bottomTitle: '',
      desc: 'Add any data source and create comprehensive segments, based on the past history of the user data',
      href: '/settings',
      queryParams: { section: 'ds' },
      alias: 'ds',
      featureName: 'data_sources',
      parentFeature: 'home_page',
      showPremium: false,
      shouldBeHidden: false
    },
    {
      headTitle: 'Apps',
      img: 'assets/images/no_data_source.png',
      bottomTitle: '',
      desc: 'Make your app configurable and start personalizing & experimenting with your user interactions',
      href: '/settings',
      alias: 'apps',
      featureName: 'apps',
      parentFeature: 'home_page',
      showPremium: false,
      shouldBeHidden: false
    },
    {
      headTitle: 'Test',
      img: 'assets/images/no_app.png',
      bottomTitle: '',
      desc: 'Add a test device to fetch events and user attributes from your integrated app for segmentation',
      href: '/test-groups',
      alias: 'tgs',
      featureName: 'test_devices',
      parentFeature: 'home_page',
      showPremium: false,
      shouldBeHidden: false
    },
    /* {
      headTitle: 'Analytics Providers',
      img: 'assets/images/svgImagesSprite.svg#undraw_setup_analytics',
      bottomTitle: '',
      desc: 'Link your analytics provider and measure the impact of your experiments on your metrics',
      href: '/settings',
      queryParams: { section: 'analytics' },
      alias: 'ap'
    }, */
    {
      headTitle: 'User Management',
      img: 'assets/images/tg-empty.png',
      bottomTitle: '',
      desc: 'User Management - Invite and collaborate with your co-workers seamlessly',
      href: '/settings',
      queryParams: { section: 'users' },
      alias: 'um',
      featureName: 'user_management',
      parentFeature: 'home_page',
      showPremium: false,
      shouldBeHidden: false
    }
  ];

  private headerData = {
    title: 'Home',
    hideApp: true,
    isOverviewPage: true,
    breadCrumb: []
  };

  public userData: any = {};
  public trialUserData: any;
  public lockedPagesOnTrial = ['ap', 'ds'];
  public lockedPagesForNoApp = ['cs', 'temps', 'segs', 'im', 'tgs'];
  public appList = [];
  public hasAppListBeenModifiedByUsage = false;
  private appChangeListener: any;
  private appChangeListenerForPremiumCheck: any;
  private userInfoSubscriber: any;
  private userPlanSubscriber: any;
  private zedaInterval;
  // Max 5 retries with AGGRESSIVE strategy (500ms → 1s → 2s → 4s → 8s), matching original behaviour
  private zedaRetries: number = 0;

  constructor(private headerService: HeaderService,
    private title: Title,
    private dialog: MatDialog,
    private router: Router,
    private trialUserService: TrialUserService,
    private environmentManagerService: EnvironmentManagerService,
    private amplitudeLoggerService: AmplitudeLoggerService,
    private appSelectorService: AppSelectorService,
    private utilService: UtilService,
    private featureListJsonService: FeatureListJsonService,
    private datacontextService: DatacontextService) { }

  ngOnInit() {
    this.datacontextService.user.sendAttributesDataForSmartechSDK();
    this.title.setTitle('Netcore PX: Home');
    this.addPremiumConditionToCards();
    this.setFeatureFlagForUpload();
    this.companyDetails = this.appSelectorService.getCompanyDetails();
    this.trialUserData = this.trialUserService.trialUserData;
    const env = this.environmentManagerService.getCurrentEnvironment();
    this.appList = this.appSelectorService.getApplist(env);
    this.handleInit();
    this.checkForProductionApp(env);
    this.updatePremiumCheckOnAppChange();
    this.amplitudeLoggerService.log(AnalyticsEvents.eventName.HOMEPAGE_VIEW, '', {});
    this.setHeaderData();
    this.getUserInfo();
    this.handleCallbackClickListener = this.handleCallbackClickListener.bind(this);
    this.getPlanForCompany();
    this.checkIfUserHasAnyAppInProduction();
    this.shouldCardBeHidden();
  }

  setInitSetupValue() {
    const env = this.environmentManagerService.getCurrentEnvironment();
    this.appList = this.appSelectorService.getApplist(env);
    if (this.appList.length) {
      this.handleAppDetailsChanges();
    } else {
      this.hasAppListBeenModifiedByUsage = true;
    }
  }

  setFeatureFlagForUpload() {
    const _this = this;
    this.featureListJsonService.shouldEnableTheFeature('event_data_upload', true, flag => {
      this.shouldShowUploadFeature = flag;
    });
  }

  handleInit() {
    if (this.appSelectorService.hasAppDetailsLoaded()) {
      this.setInitSetupValue();
    } else {
      this.appSelectorService.promisifyAppListAndCount()
        .then(() => this.setInitSetupValue());
    }
  }

  shouldCardBeHidden() {
    this.cards.forEach(card => {
      // tslint:disable-next-line: max-line-length
      this.featureListJsonService.shouldEnableTheFeature(`${card.parentFeature}.${card.featureName}`, 'hidden', flag => card.shouldBeHidden = flag);
    });
  }

  updatePremiumCheckOnAppChange() {
    this.appChangeListenerForPremiumCheck = this.appSelectorService.getAppChangedListener().subscribe(selectedApp => {
      const env = this.environmentManagerService.getCurrentEnvironment();
      this.addPremiumConditionToCards();
      this.shouldCardBeHidden();
      this.setFeatureFlagForUpload();
    });
  }

  handleAppDetailsChanges() {
    this.appSelectorService.promisifyAppListAndCount()
      .then(() => {
        const env = this.environmentManagerService.getCurrentEnvironment();
        const appList = cloneDeep(this.appSelectorService.getApplist(env));
        if (!appList || !appList.length) {
          this.hasAppListBeenModifiedByUsage = true;
          return;
        }
        const appListIdMap = this.appSelectorService.mapAppIdWithApp(appList);
        const appDetailsCount = this.appSelectorService.getAppDetailsCount() || {};
        const appListByUsage = this.appSelectorService.getAppListByUsage() || {};
        this.mergeAppDetails(appListIdMap, appDetailsCount);
        this.appList = this.reOrderAppBasedOnUsage(appListIdMap, appListByUsage);
        this.appList.map(app => {
          const homePage = 'home_page';
          const items = ['test_devices', 'interaction_maps', 'user_segments']
          // tslint:disable-next-line: max-line-length
          items.forEach(item => this.featureListJsonService.shouldAppBeEnabled(`${homePage}.${item}`, 'disabled', app, flag => app[`${item}_disabled`] = flag));
          // tslint:disable-next-line: max-line-length
          items.forEach(item => this.featureListJsonService.shouldAppBeEnabled(`${homePage}.${item}`, 'hidden', app, flag => app[`${item}_hidden`] = flag));
        });
        this.hasAppListBeenModifiedByUsage = true;
      });
  }

  reOrderAppBasedOnUsage(appsListById, appListByUsage) {
    if (appListByUsage && !appListByUsage.length) {
      return this.appSelectorService.unMapAppIdWithApp(appsListById);
    }
    const recentApps = [];
    appListByUsage.forEach((appId: string) => {
      if (appsListById.hasOwnProperty(appId)) {
        recentApps.push(appsListById[appId]);
        delete appsListById[appId];
      }
    });
    const filteredApp = this.appSelectorService.unMapAppIdWithApp(appsListById);
    return [...recentApps, ...filteredApp];
  }

  mergeAppDetails(appIdList, appDetailsCount) {
    const keys = Object.keys(appIdList);
    keys.forEach(key => {
      if (appDetailsCount.hasOwnProperty(key)) {
        const props = Object.keys(appDetailsCount[key]);
        props.forEach(prop => {
          appIdList[key][prop] = appDetailsCount[key][prop];
        });
      }
    });
  }

  checkForProductionApp(env) {
    this.appChangeListener = this.appSelectorService.getAppChangedListener().subscribe((selectedApp) => {
      this.appList = this.appSelectorService.getApplist(env);
      setTimeout(() => this.handleAppDetailsChanges());
      this.checkIfUserHasAnyAppInProduction();
      this.appChangeListener.unsubscribe();
      this.appChangeListener = null;
    });
  }

  checkIfUserHasAnyAppInProduction() {
    let productionApps = this.appList.filter(app => app.app_state === 'production');
    this.productionAppCount = productionApps.length;
  }

  getPlanForCompany() {
    this.userPlanSubscriber = this.datacontextService.user.getUserCompany((res: any) => {
      const _companyDetails = res.api_response.companies[0];
      delete _companyDetails.apps;
      this.plan = _companyDetails.plan;
      this.maxProductionAppCount = _companyDetails.max_live_app_count === -1 ? 'Unlimited' : _companyDetails.max_live_app_count;
    });
  }

  addPremiumConditionToCards() {
    this.cards.forEach(card => {
      // tslint:disable-next-line: max-line-length
      this.featureListJsonService.shouldEnableTheFeature(`${card.parentFeature}.${card.featureName}`, 'disabled', flag => card['showPremium'] = flag);
    })
  }

  handleCallbackClickListener(featureName) {
    let featureArr = this.cards.filter(card => card.featureName === featureName);
    let featureObject: any = {};
    if (featureArr.length) {
      featureObject = featureArr[0];
      if (featureObject.alias) {
        if (featureObject.alias in AnalyticsEvents.analyticsCtaMap) {
          this.trackClick(AnalyticsEvents.analyticsCtaMap[featureObject.alias], { disabled: true });
        } else {
          this.trackClick(featureObject.alias, { disabled: true });
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.appChangeListener) {
      this.appChangeListener.unsubscribe();
      this.appChangeListener = null;
    }
    if (this.appChangeListenerForPremiumCheck) {
      this.appChangeListenerForPremiumCheck.unsubscribe();
      this.appChangeListenerForPremiumCheck = null;
    }
    if (this.userInfoSubscriber) {
      this.userInfoSubscriber.unsubscribe();
      this.userInfoSubscriber = null;
    }
    if (this.userPlanSubscriber) {
      this.userPlanSubscriber.unsubscribe();
      this.userPlanSubscriber = null;
    }
    clearTimeout(this.zedaInterval);
  }

  setHeaderData() {
    const _this = this;
    const _breadCrumb: any = [{ 'txt': 'HOME' }];
    _this.headerData.breadCrumb = _breadCrumb;
    _this.headerService.setHeaderData(_this.headerData);
  }

  getUserInfo() {
    this.userInfoSubscriber = this.datacontextService.user.getUserInfo((res: any) => {
      this.userData = res.api_response;
      if (!this.datacontextService.user.hasZedaBeenInitialized) {
        this.checkForZeda();
      }
    });
  }

  getAppPlatformTitle(os) {
    return this.appSelectorService.getAppPlatformTitle(os);
  }

  trackClick(cta, eventData) {
    const { eventName: { HOMEPAGE_MENU_CLICK, HOMEPAGE_CREATE_APP, HOMEPAGE_INVITE_MEMBER } } = AnalyticsEvents;
    // tslint:disable-next-line: max-line-length
    const eventName = cta === this.CREATE_CTA ? HOMEPAGE_CREATE_APP : cta === this.INVITE_CTA ? HOMEPAGE_INVITE_MEMBER : HOMEPAGE_MENU_CLICK;
    this.amplitudeLoggerService.log(eventName, cta, eventData);
  }

  navigateToSettingPage(route, queryParams) {
    this.router.navigate([route], { queryParams: queryParams }).catch(err => {
      window.history.pushState({}, document.title, route + (queryParams ? this.serialize(queryParams) : ''));
      window.location.reload();
    });
  }

  navigateTo(routeData: any) {
    // change route
    if (this.lockedPagesForNoApp.includes(routeData.cta) && !this.appList.length) {
      return;
    }
    if (routeData.cta) {
      if (routeData.cta in AnalyticsEvents.analyticsCtaMap) {
        this.trackClick(AnalyticsEvents.analyticsCtaMap[routeData.cta], {});
      } else {
        this.trackClick(routeData.cta, {});
      }
    }
    this.router.navigate([routeData.href], { queryParams: routeData.queryParams }).catch(err => {
      // Handle here
      window.history.pushState({}, document.title, routeData.href + (routeData.queryParams ? this.serialize(routeData.queryParams) : ''));
      window.location.reload();
    });
  }

  serialize(obj) {
    const str = [];
    for (const p in obj) {
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
      }
    }
    return str.join('&');
  }

  openAddUserForm() {
    this.trackClick(this.INVITE_CTA, {});
    this.companyDetails = this.appSelectorService.getCompanyDetails();
    this.getPlanForCompany();
    this.addUserDialogRef = this.dialog.open(AddUserComponent, {
      panelClass: 'full-screen-dialog-container',
      disableClose: true,
      data: { companyId: this.companyDetails.id }
    });

    this.addUserDialogRef.afterClosed().subscribe(result => {
      if (result && result.email) {
      }
    });
  }

  handleAppLimit() {
    if (!this.shouldStickToAppLimit) {
      const scrollBehavior: any = {
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
      };
      setTimeout(() => {
        document.querySelector('#app-head').scrollIntoView(scrollBehavior);
      });
    }
    this.shouldStickToAppLimit = !this.shouldStickToAppLimit;
  }

  // navigate to page on app card link click.
  navigateToPage(route, appObj, objBlockProps: any, queryParams = {}) {
    if (objBlockProps && objBlockProps.disable) {
      return;
    }
    this.appSelectorService.setSelectedApp(appObj);
    setTimeout(() => {
      this.router.navigate([route], { queryParams: queryParams }).catch(err => {
        window.history.pushState({}, document.title, route + (queryParams ? this.serialize(queryParams) : ''));
      });
    })
  }

  setHoverTrue(evt, app: any = {}) {
    evt.preventDefault();
    evt.stopPropagation();
    if (app && Object.keys(app).length) {
      app.hoveringOverCard = true;
    }
  }

  setHoverFalse(evt, app: any = {}) {
    evt.preventDefault();
    evt.stopPropagation();
    if (app && Object.keys(app).length) {
      app.hoveringOverCard = false;
    }
  }

  filterAppListByLimit(limit) {
    if (this.shouldStickToAppLimit) {
      return this.appList.slice(0, limit);
    }
    return this.appList;
  }

  redirectToAppsettings(app, event) {// change route
    this.utilService.stopEventBubbling(event);
    if (!app) {
      return;
    }
    const appId = app.id;
    this.appSelectorService.setSelectedApp(app);
    this.router.navigate(['/app-settings/view-app'], { queryParams: { appId: appId } }).catch(err => {
      // Handle here
      window.history.pushState({}, document.title, '/app-settings/view-app?appId=' + appId);
      window.location.reload();
    });
  }

  redirectToAppJourneysPage(app) {// change route
    if (app && app.id) {
      this.appSelectorService.setSelectedApp(app);
    }
    const path = app.os === 'be' ? 'feature-management' : 'nudge-journeys';
    this.router.navigate([`/context-builder/${path}`]).catch(err => {
      // Handle here
      window.history.pushState({}, document.title, '/context-builder/nudge-journeys');
      window.location.reload();
    });
  }

  openCreateAppForm() {
    this.createAppDialogRef = this.dialog.open(CreateAppComponent, {
      panelClass: 'full-screen-dialog-container',
      disableClose: true
    });

    this.createAppDialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.router.navigate(['/settings']);
        this.appSelectorService.loadApps(null, () => {
          const env = this.environmentManagerService.getCurrentEnvironment();
          const appList = this.appSelectorService.getApplist(env);
          let createdApp = {};
          appList.forEach(app => {
            if (app.id === result.api_response.id) {
              createdApp = app;
            }
          });
          this.appSelectorService.setSelectedApp(createdApp);
          this.router.navigate(['app-settings'], { queryParams: { 'new-app': true } });
        });
      }
    });
  }

  initZeda() {
    window['zeda'].init({email: this.userData.email, name: this.userData.name});
    clearTimeout(this.zedaInterval);
    this.datacontextService.user.hasZedaBeenInitialized = true;
  }

  checkForZeda() {
    if (window['zeda'] && window['zeda'].init) {
      this.initZeda();
      return;
    }

    if (ExponentialBackoffRetryService.shouldStopRetrying(this.zedaRetries, RETRY_STRATEGIES.AGGRESSIVE)) {
      console.warn('Zeda SDK initialization timeout - max retries reached');
      return;
    }

    const nextRetryDelay = ExponentialBackoffRetryService.getRetryDelay(
      this.zedaRetries,
      RETRY_STRATEGIES.AGGRESSIVE
    );

    // Increment before scheduling so each recursive call sees the updated count
    this.zedaRetries++;
    // Use setTimeout (not setInterval) — fires once, then checkForZeda recurses if needed.
    // setInterval would stack new intervals on each retry without cancelling the previous one.
    this.zedaInterval = setTimeout(() => {
      if (window['zeda'] && window['zeda'].init) {
        this.initZeda();
      } else {
        this.checkForZeda();
      }
    }, nextRetryDelay);
  }
}
